/* PriceIsKing Theme JS */
'use strict';

document.addEventListener('DOMContentLoaded', function () {

  // ─── Mobile Menu Toggle ────────────────────────────────────────────
  const menuBtn = document.querySelector('[data-menu-btn]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const menuIcon = document.querySelector('[data-menu-icon]');

  const ICON_MENU = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="18" y2="18"/></svg>`;
  const ICON_CLOSE = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', String(isOpen));
      if (menuIcon) menuIcon.innerHTML = isOpen ? ICON_CLOSE : ICON_MENU;
    });
  }

  // ─── Cart Count Refresh ───────────────────────────────────────────
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  // ─── Add To Cart ──────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-atc-btn]');
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartCount();
        if (btn) {
          btn.textContent = 'Added!';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 2000);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Error — Try Again'; }
      });
  });

  // ─── Cart Qty Change ──────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: input.dataset.line, quantity: parseInt(input.value, 10) })
    }).then(function () { location.reload(); }).catch(function () {});
  });

  // ─── Cart Remove ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-item]');
    if (!btn) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: btn.dataset.line, quantity: 0 })
    }).then(function () { location.reload(); }).catch(function () {});
  });

  // ─── Newsletter form (basic prevent-default for Shopify contact_form tag) ─
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var checkbox = form.querySelector('[data-newsletter-consent]');
      if (checkbox && !checkbox.checked) {
        e.preventDefault();
        alert('Please confirm you agree to receive updates.');
      }
    });
  });

  // ─── Hero Carousel ────────────────────────────────────────────────
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var slides    = Array.from(carousel.querySelectorAll('.pik-carousel__slide'));
    var dots      = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    var prevBtn   = carousel.querySelector('[data-carousel-prev]');
    var nextBtn   = carousel.querySelector('[data-carousel-next]');
    var progBar   = carousel.querySelector('[data-progress-bar]');
    var speed     = (parseInt(carousel.dataset.autoplay, 10) || 6) * 1000;
    var mode      = carousel.dataset.transition || 'fade';
    var current   = 0;
    var total     = slides.length;
    var timer     = null;
    var progTimer = null;
    var paused    = false;

    if (total <= 1) return;

    function goTo(index, direction) {
      if (index === current) return;
      var prev = current;
      current = (index + total) % total;

      if (mode === 'slide') {
        var incoming = slides[current];
        var outgoing = slides[prev];
        // Position incoming off-screen in the correct direction
        incoming.style.transform = direction === 'prev' ? 'translateX(-100%)' : 'translateX(100%)';
        incoming.classList.add('is-active');
        // Force reflow
        incoming.offsetHeight; // eslint-disable-line no-unused-expressions
        // Animate both
        incoming.style.transform = 'translateX(0)';
        outgoing.style.transform = direction === 'prev' ? 'translateX(100%)' : 'translateX(-100%)';
        outgoing.classList.add('is-leaving');
        outgoing.classList.remove('is-active');
        // Clean up after transition
        var cleanup = function () {
          outgoing.classList.remove('is-leaving');
          outgoing.style.transform = '';
          incoming.style.transform = '';
        };
        incoming.addEventListener('transitionend', cleanup, { once: true });
      } else {
        // Fade
        slides[prev].classList.remove('is-active');
        slides[current].classList.add('is-active');
      }

      // Update dots
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', String(i === current));
      });

      resetProgress();
    }

    function next() { goTo(current + 1, 'next'); }
    function prev() { goTo(current - 1, 'prev'); }

    // Auto-advance timer
    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () {
        if (!paused) next();
      }, speed);
    }

    // Progress bar animation
    function resetProgress() {
      if (!progBar) return;
      clearTimeout(progTimer);
      progBar.style.transition = 'none';
      progBar.style.width = '0%';
      progBar.offsetHeight; // reflow
      progBar.style.transition = 'width ' + (speed / 1000) + 's linear';
      progBar.style.width = '100%';
    }

    // Pause on hover / focus
    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { paused = false; });
    carousel.addEventListener('focusin',    function () { paused = true; });
    carousel.addEventListener('focusout',   function () { paused = false; });

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startTimer(); });

    // Dot buttons
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.carouselDot, 10);
        goTo(idx, idx > current ? 'next' : 'prev');
        startTimer();
      });
    });

    // Touch / swipe support
    var touchStartX = null;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var delta = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 40) return;
      if (delta < 0) { next(); } else { prev(); }
      startTimer();
    }, { passive: true });

    // Keyboard navigation when carousel is focused
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { prev(); startTimer(); }
      if (e.key === 'ArrowRight') { next(); startTimer(); }
    });

    // Boot
    startTimer();
    resetProgress();
  });

  // ─── Product Variant Picker ───────────────────────────────────────────
  (function () {
    var dataEl = document.getElementById('PIKProductData');
    if (!dataEl) return;

    var productData = JSON.parse(dataEl.textContent);
    var variants    = productData.variants;
    var moneyFormat = productData.moneyFormat;

    function formatMoney(cents) {
      if (cents === 0) return 'Free';
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.floor(cents / 100).toString())
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.floor(cents / 100).toString());
    }

    function getSelectedVariant() {
      var heroSelects = Array.from(document.querySelectorAll('[data-hero-option]'))
        .sort(function (a, b) {
          return parseInt(a.dataset.heroOption, 10) - parseInt(b.dataset.heroOption, 10);
        });

      if (!heroSelects.length) return variants[0] || null;

      var selectedOptions = heroSelects.map(function (sel) { return sel.value; });

      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) return;

      var price        = variant.price;
      var comparePrice = variant.compare_at_price;
      var hasSaving    = comparePrice && comparePrice > price;
      var priceText    = price === 0 ? 'Free' : formatMoney(price);

      document.querySelectorAll('[data-price-display]').forEach(function (el) {
        el.textContent = priceText;
      });

      document.querySelectorAll('[data-compare-display]').forEach(function (el) {
        if (hasSaving) {
          el.textContent = formatMoney(comparePrice);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      document.querySelectorAll('[data-sale-badge]').forEach(function (el) {
        if (hasSaving) {
          el.textContent = 'SAVE ' + formatMoney(comparePrice - price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      document.querySelectorAll('[data-variant-input]').forEach(function (input) {
        input.value = variant.id;
      });

      document.querySelectorAll('[data-atc-btn]').forEach(function (btn) {
        btn.disabled = !variant.available;
        if (!variant.available) {
          btn.textContent = 'Sold Out';
        } else if (price === 0) {
          btn.textContent = 'Download Free';
        } else {
          btn.textContent = 'Add to Cart';
        }
      });
    }

    function syncAndUpdate(sourceAttr, index, newValue) {
      var pairKey = sourceAttr === 'data-hero-option'
        ? 'data-bottom-option'
        : 'data-hero-option';
      var pair = document.querySelector('[' + pairKey + '="' + index + '"]');
      if (pair && pair.value !== newValue) pair.value = newValue;
      updateUI(getSelectedVariant());
    }

    document.querySelectorAll('[data-hero-option]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        syncAndUpdate('data-hero-option', sel.dataset.heroOption, sel.value);
      });
    });

    document.querySelectorAll('[data-bottom-option]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        syncAndUpdate('data-bottom-option', sel.dataset.bottomOption, sel.value);
      });
    });
  }());

});
